module.exports = {"id":"207946","name":"Ibrahima Touré","rating":"71","photo":"./data/images/photos/3/207946.png","club":{"name":"GFC Ajaccio","logo":"./data/images/clubs/GFCAjaccio.png"},"positions":["BU"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/IbrahimaToure0.json
// module id = 1773
// module chunks = 0